<template>
  <div class="main-container">
    <div class="class-type">
      <div
        class="type-item"
        v-for="(item, index) in typeTab"
        :key="index"
        @click="clickTypeTab(index)"
        :class="{ 'active-1': index == typeActive}"
      >
        <img :src="item.icon" />
        <div class="title-desc">
          <div class="title-box">
            <span class="title">{{ item.title }}</span>
            <div class="tag" v-if="item.newNum">上新{{ item.newNum }}</div>
          </div>
          <span class="desc">{{ item.desc }}</span>
        </div>
      </div>
    </div>

    <!-- 文章素材 -->
    <articleMaterials v-if="typeActive == 0" ref="articleRef"></articleMaterials>

    <!-- 海报素材 -->
    <posterMaterial v-if="typeActive == 1" ref="posterRef"></posterMaterial>

    <!-- 朋友圈素材 -->
    <momentMaterials v-if="typeActive == 2" ref="momentRef"></momentMaterials>

    <!-- 培训中心 -->
    <trainingCenterMaterial v-if="typeActive == 3" ref="trainingCenterRef"></trainingCenterMaterial>
  </div>
</template>

<script>
import articleMaterials from './components/articleMaterials';
import posterMaterial from './components/posterMaterial';
import momentMaterials from './components/momentMaterials';
import trainingCenterMaterial from './components/trainingCenterMaterial';

export default {
  components: {
    articleMaterials,
    posterMaterial,
    momentMaterials,
    trainingCenterMaterial
  },
  activated() { 
    if(this.$route.query.typeIndex && this.$route.query.time && this.$units.formatDate(new Date(JSON.parse(this.$route.query.time)), 'yyyy-MM-dd hh:mm:ss') == this.$units.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')){
      this.typeActive = this.$route.query.typeIndex
    }
    // if (!localStorage.getItem('formDetailPage')) {
    //   this.getNewStatistics();
    //   this.clickTypeTab(this.typeActive);
    // }
    // localStorage.removeItem('formDetailPage')
  },
  created() {
    this.$nextTick(()=>{
      this.clickTypeTab(this.typeActive || 0);
    })
    
  },
  data() {
    return {
      typeActive: 0,
      typeTab: [
        {
          icon: require('@/static/images/contentManage/01.png'),
          title: '文章素材',
          desc: '海量产品解读、热点资讯',
          newNum: '',
          type: '1'
        },
        {
          icon: require('@/static/images/contentManage/02.png'),
          title: '海报中心',
          desc: '各类营销海报、一应俱全',
          newNum: '',
          type: '2'
        },
        {
          icon: require('@/static/images/contentManage/03.png'),
          title: '朋友圈助手',
          desc: '朋友圈营销的加油包',
          newNum: '',
          type: '3'
        },
        {
          icon: require('@/static/images/contentManage/04.png'),
          title: '培训中心',
          desc: '代理人知识充电站',
          newNum: '',
          type: '4'
        }
      ]
    };
  },
  methods: {
    clickTypeTab(index) {
      this.typeActive = index;
      this.$nextTick(() => {
        if (index == 0) {
          this.$refs.articleRef.getData();
        } else if (index == 1) {
          this.$refs.posterRef.getData();
        } else if (index == 2) {
          this.$refs.momentRef.getData();
        } else if (index == 3) {
          this.$refs.trainingCenterRef.getData();
        }
      });
    },
    getNewStatistics() {
      this.$http({
        url: '/buz/cms/materialsLibrary/publish/statistics',
        type: 'GET'
      }).then(res => {
        this.typeTab.forEach(item => {
          res.data.forEach(item2 => {
            if (item.type == item2.type) {
              item.newNum = item2.nums;
            }
          });
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.class-type {
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  .type-item {
    border: 1px solid #f5f7f9;
    width: 24%;
    display: flex;
    align-items: center;
    padding: 26px 30px;
    background: #f5f7f9;
    border-radius: 4px;
    cursor: pointer;
    img {
      width: 34px;
      height: 34px;
    }
    .title-desc {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .title-box {
        display: flex;
        .title {
          font-size: 16px;
          color: #3c464f;
          font-weight: bold;
        }
        .tag {
          width: 40px;
          height: 20px;
          margin-left: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #fff;
          background: url(../../../static/images/contentManage/06.gif);
          background-size: 100% 100%;
        }
      }
      .desc {
        font-size: 14px;
        color: #727c8e;
        margin-top: 8px;
      }
    }
    &.active-0 {
      background: #e8efff;
      border: 1px solid #3069f0;
      border-radius: 4px;
      .desc {
        color: #3069f0;
      }
      .title-box {
        .title {
          color: #3069f0;
        }
      }
    }
    &.active-1 {
      background: #DDF1FF;
      border: 1px solid #1B93FF;
      border-radius: 4px;
      .desc {
        color: #0093FF;
      }
      .title-box {
        .title {
          color: #0093FF;
        }
      }
    }
  }
}
</style>
